import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'payment-link-open-send',
  templateUrl: './payment-link-open-send.component.html',
  styleUrls: ['./payment-link-open-send.component.scss']
})
export class PaymentLinkOpenSendComponent implements OnInit {

  @Input("id") id = null;

  constructor() { }

  /**
   * 
   * Open send
   * 
   */
  open(){

    window.open("/payment-link/order/"+this.id,"_blank");

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{}

}
